import api from "axios";

export function getGlobalFlagsCompany() {
  return api
    .get("/purchasers/companyFlags")
    .then((response) => response.data.payload.data);
}
